import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { recentBuyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const show = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), SHOW_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto md:bottom-6 md:left-6" aria-live="polite" data-id="element-23" data-mp="114thjz5k787j">
      <AnimatePresence data-id="element-24" data-mp="1aw61m4l48u30">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-brand/10 bg-white p-3 pr-9 shadow-[0_12px_32px_-8px_rgba(16,33,61,0.35)] sm:w-[340px]" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-25" data-mp="1aysg6o6fc9uq">
            <img src={images.mainMockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-sand object-contain" data-id="element-26" data-mp="23ldanxi7522i" />
            <div className="min-w-0 text-left" data-id="element-27" data-mp="2aoth44aubfdx">
              <p className="text-sm font-bold text-ink" data-id="element-28" data-mp="2ao1ql7w3o7ui">
                {buyer.name} from {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-29" data-mp="2fphauxqgeabu">just purchased The Sensory Clinical Route™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-30" data-mp="2pltz3g38bvz7">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="1ry3gkm8qs4o8" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-sand hover:text-ink" aria-label="Close notification" data-id="element-32" data-mp="1wxof4vk02b0f">
              <XIcon className="h-4 w-4" data-id="element-33" data-mp="1983wyevo7hs7" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}